/* eslint-disable prefer-destructuring */
import { Pv } from '@weblite/ts-action/pv'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

type PvUpdatePatch = Partial<
  Pick<Pv, 'muted' | 'firstVisibleIid' | 'unreadMark'>
>
const synchronizer = eventBasedSynchronizer<PvUpdatePatch, true>('pvSync', {
  merge: true,
})

export const set = synchronizer.set
export const getAll = synchronizer.getAll
export const getIds = synchronizer.getIds
